module.exports = __webpack_public_path__ + "img/net-sentiment.bc013dac.png";